import { defineStore } from 'pinia'
import { collection } from '@firebase/firestore'
import { useWorkspacesStore } from '~/store/workspaces'
import type { Organization } from '~/types/organizations'
import { Collections } from '~/constants/firebase'

type SelectedOrganization = Organization | null

export const useOrganizationsStore = defineStore('organizationsStore', () => {
  const userOrganizations = ref<Organization[]>([])
  // TODO: Check if computed is right to use here
  const organizations = computed<Organization[]>(() =>
    userOrganizations.value.map(({ organization }) => organization),
  )
  function setOrganizations(value: Organization[]) {
    userOrganizations.value = value
  }
  async function getOrganizations() {
    const userUid = (await getCurrentUser()).uid
    await new Promise((resolve) => {
      const { promise } = useCollection(
        collection(
          useGetFirestore(),
          Collections.Users.Organizations.base(userUid),
        ),
        { wait: true },
      )
      promise.value.then((organizations) => {
        setOrganizations(organizations)
        resolve()
      })
    })
  }

  const selectedOrganization = ref<SelectedOrganization>(null)
  function setSelectedOrganization(value: SelectedOrganization | null) {
    selectedOrganization.value = value
    if (!selectedOrganization.value) {
      const workspacesStore = useWorkspacesStore()
      workspacesStore.setSelectedWorkspace(null)
    }

    const { $sentrySetTag } = useNuxtApp()
    $sentrySetTag('organizationId', value?.id)
  }

  // To watch organization changes and apply them directly in interface
  watch(organizations, (newVal) => {
    const selectedOrgIndex = newVal.findIndex(
      org => org.id === selectedOrganization.value?.id,
    )

    if (selectedOrgIndex >= 0) {
      selectedOrganization.value = newVal[selectedOrgIndex]
    }
  })

  function $reset() {
    userOrganizations.value = []
    selectedOrganization.value = null
  }

  return {
    organizations,
    getOrganizations,
    selectedOrganization,
    setSelectedOrganization,
    $reset,
  }
})
